import { FC } from "react";
import { SidebarProps } from "./sidebar.types";

import classNames from "classnames";
import {
  Sidebar as ReactAdminSidebar,
  useLocale,
  useSidebarState,
} from "react-admin";
import styles from "./sidebar.module.css";

const Sidebar: FC<SidebarProps> = ({ children }) => {
  useLocale();
  const [open, setOpen] = useSidebarState();

  const toggleSidebar = () => setOpen(!open);

  return (
    <ReactAdminSidebar
      open={open}
      onToggle={toggleSidebar}
      className={classNames(styles.sidebar, open && styles.rightBorder)}
    >
      {children}
    </ReactAdminSidebar>
  );
};

export { Sidebar };
